<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Reajuste de Preços</h1>
            <p class="welcome-message">
              <button mat-icon-button (click)="voltar()">
                <mat-icon>arrow_back</mat-icon>
              </button>
              Histórico de reajustes aplicados
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <button type="button" mat-flat-button class="btn-primary" (click)="novoReajuste()">
          <mat-icon class="material-symbols-outlined">add</mat-icon>
          Novo reajuste de preço
        </button>
      </div>
    </div>

    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" formControlName="pesquisa" placeholder="Pesquise pela lista de preço" />
            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 filter-container">
          <button mat-stroked-button type="button" class="btn-filter" [matMenuTriggerFor]="filtroMenu"
            [matBadge]="qtdFiltrosAvancados" [matBadgeHidden]="qtdFiltrosAvancados === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>
          <mat-menu #filtroMenu="matMenu">
            <div class="filter-menu-content" [formGroup]="model">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros Avançados</h6>

                <div class="filter-menu__form">
                  <app-select-pesquisavel label="Usuário" [control]="$any(model.get('listIdUsuario'))"
                    [idField]="'idUsuario'" [nameField]="'nomeUsuario'" [offlineList]="usuarios" [multiple]="true"
                    [isOptional]="true" hint="Filtrar por usuário">
                  </app-select-pesquisavel>
                </div>
              </div>

              <div class="filter-menu__actions">
                <button mat-button class="btn-secondary" matMenuClose>Cancelar</button>
                <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>Aplicar</button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>
        </div>
      </div>
    </form>

    @if (dataSource.data.length > 0) {
      <div class="table-responsive desktop-view">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="dataHora">
          <th mat-header-cell *matHeaderCellDef>Data / Hora</th>
          <td mat-cell *matCellDef="let item">{{ item.datetimeInclusao | date: 'dd/MM/yyyy HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="usuario">
          <th mat-header-cell *matHeaderCellDef>Usuário</th>
          <td mat-cell *matCellDef="let item">{{ nomeUsuario(item.idUsuario) }}</td>
        </ng-container>

        <ng-container matColumnDef="listaPreco">
          <th mat-header-cell *matHeaderCellDef>Lista de Preço</th>
          <td mat-cell *matCellDef="let item">{{ item.listaPreco }}</td>
        </ng-container>

        <ng-container matColumnDef="produtos">
          <th mat-header-cell *matHeaderCellDef class="text-end">Produtos</th>
          <td mat-cell *matCellDef="let item" class="text-end">{{ item.qtdProdutos }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
          <td mat-cell *matCellDef="let item" class="text-center">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
              <span class="material-symbols-outlined">more_horiz</span>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="visualizar(item.idProdutoReajustePreco)">
                <span class="material-symbols-outlined">visibility</span>
                <span>Visualizar</span>
              </button>
              @if (item.idNFeEntrada) {
              <a mat-menu-item [routerLink]="['/suprimentos/nota-fiscal-entrada/documento', item.idNFeEntrada]" [queryParams]="{ modo: 'visualizar' }">
                <span class="material-symbols-outlined">receipt_long</span>
                <span>NF-e de entrada</span>
              </a>
              }
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      </div>

      <div class="mobile-view">
        @for (item of dataSource.data; track item.idProdutoReajustePreco) {
          <div class="card-mobile mb-3">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
              <div class="d-flex flex-column">
                <span class="text-bold">{{ item.listaPreco }}</span>
                <small>{{ item.datetimeInclusao | date: 'dd/MM/yyyy HH:mm' }} · {{ nomeUsuario(item.idUsuario) }}</small>
              </div>
              <button mat-icon-button [matMenuTriggerFor]="menuMobile">
                <span class="material-symbols-outlined">more_horiz</span>
              </button>
              <mat-menu #menuMobile="matMenu">
                <button mat-menu-item (click)="visualizar(item.idProdutoReajustePreco)">Visualizar</button>
                @if (item.idNFeEntrada) {
                <a mat-menu-item [routerLink]="['/suprimentos/nota-fiscal-entrada/documento', item.idNFeEntrada]" [queryParams]="{ modo: 'visualizar' }">NF-e de entrada</a>
                }
              </mat-menu>
            </div>
            <div class="card-body-mobile p-3">
              <small class="d-block">Produtos</small>
              <span>{{ item.qtdProdutos }}</span>
            </div>
          </div>
        }
      </div>

      <div class="col-12 text-center mt-4 mb-5">
        <button mat-button [disabled]="ultimaPagina" (click)="proximaPagina()">
          @if (isLoading) {
            <mat-spinner [diameter]="20"></mat-spinner>
          } @else {
            <span class="material-symbols-outlined">expand_more</span>
            Ver Mais
          }
        </button>
      </div>
    } @else if (isLoading) {
      <app-loading-box-default-list></app-loading-box-default-list>
    } @else {
      <app-empty-list [title]="'Nenhum reajuste encontrado'"
        [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
    }
  </div>
</div>
